import React, { useState } from 'react';
import {
  Paper,
  Tabs,
  Tab,
  AppBar,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dashboard as DashboardIcon,
  Assignment as AssignmentIcon
} from '@material-ui/icons';

// Importar las 2 vistas
import Vista1ResumenEstrategico from './Vista1ResumenEstrategico';
import Vista2DetalleSolicitudes from './Vista2DetalleSolicitudes';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  tabsContainer: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #e0e0e0',
  },
  tabContent: {
    padding: 0,
  },
  tab: {
    minHeight: 72,
    textTransform: 'none',
    fontSize: '0.9rem',
    fontWeight: 600,
    '&.Mui-selected': {
      color: '#1976d2',
    },
  },
  tabPanel: {
    minHeight: '60vh',
  },
}));

const PlazasIntegradas = ({ selectedCarrera, selectedUniversidad, filtrosActivos = {} }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Función para renderizar el contenido de cada pestaña
  const renderTabContent = () => {
    switch (activeTab) {
      case 0: // Vista 1: Resumen por Servicio-Carrera
        return (
          <Vista1ResumenEstrategico
            selectedCarrera={selectedCarrera}
            selectedUniversidad={selectedUniversidad}
            filtrosActivos={filtrosActivos}
          />
        );

      case 1: // Vista 2: Análisis por Universidad
        return (
          <Vista2DetalleSolicitudes
            selectedCarrera={selectedCarrera}
            selectedUniversidad={selectedUniversidad}
            filtrosActivos={filtrosActivos}
          />
        );

      default:
        return (
          <Vista1ResumenEstrategico 
            selectedCarrera={selectedCarrera}
            selectedUniversidad={selectedUniversidad}
            filtrosActivos={filtrosActivos}
          />
        );
    }
  };

  return (
    <div className={classes.root}>
      <Paper>
        {/* Navegación por pestañas */}
        <AppBar position="static" color="default" elevation={0} className={classes.tabsContainer}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              icon={<DashboardIcon />}
              label="Resumen por Servicio-Carrera"
              className={classes.tab}
            />
            <Tab
              icon={<AssignmentIcon />}
              label="Análisis por Universidad"
              className={classes.tab}
            />
          </Tabs>
        </AppBar>

        {/* Contenido de la pestaña activa */}
        <Box className={classes.tabContent}>
          <div className={classes.tabPanel}>
            {renderTabContent()}
          </div>
        </Box>
      </Paper>
    </div>
  );
};

export default PlazasIntegradas;
